import { apiCall } from '@/lib/api-client';
import type { QueueResponse, NextClientResponse } from '@/types/api';

export const queueApi = {
  /** GET /agents/me/queue — one page of pending+in_progress (no PHI). */
  list: (opts?: { limit?: number; offset?: number }) => {
    const limit = opts?.limit ?? 50;
    const offset = opts?.offset ?? 0;
    return apiCall<QueueResponse>(
      `/agents/me/queue?limit=${encodeURIComponent(String(limit))}&offset=${encodeURIComponent(String(offset))}`,
    );
  },

  /**
   * POST /agents/me/queue/take-next — atomically claim next assignment.
   * Returns 404 if nothing pending.
   */
  takeNext: () =>
    apiCall<NextClientResponse>('/agents/me/queue/take-next', {
      method: 'POST',
    }),
};
